import {
    PROFILE_LOADING,
    PROFILE_GET_CONTACT_INFO,
    PROFILE_SET_CONTACT_INFO,
    PROFILE_GET_GENERAL_AVAILABILITY,
    PROFILE_SET_GENERAL_AVAILABILITY,
    PROFILE_GET_TRAVEL_INFO,
    PROFILE_SET_TRAVEL_INFO,

    PROFILE_GET_VACATIONS,
    PROFILE_GET_VACATIONS_BY_ID,
    PROFILE_SET_VACATIONS,

    PROFILE_GET_SPECIAL,
    PROFILE_GET_SPECIAL_BY_ID,
    PROFILE_SET_SPECIAL
} from "api/menu/profile/actions";

const initialState = {
    loading: false,

    contactInfo: {},
    travelPreferences: {},
    generalAvailability: {},

    vacations: [],
    singleVacations: {},

    specialAvailability: [],
    singleSpecialAvailability: {}
};

export default function(state = initialState, action) {
    let vacations,
        specialAvailability,
        index;
    switch (action.type) {
        case PROFILE_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case PROFILE_GET_CONTACT_INFO:
            return {
                ...state,
                loading: false,
                contactInfo: action.payload
            };
        case PROFILE_SET_CONTACT_INFO:
            return {
                ...state,
                loading: false
            };
        case PROFILE_GET_GENERAL_AVAILABILITY:
            return {
                ...state,
                loading: false,
                generalAvailability: action.payload
            };
        case PROFILE_SET_GENERAL_AVAILABILITY:
            return {
                ...state,
                loading: false,
                generalAvailability: action.payload
            };
        case PROFILE_GET_TRAVEL_INFO:
            return {
                ...state,
                loading: false,
                travelPreferences: action.payload
            };
        case PROFILE_SET_TRAVEL_INFO:
            return {
                ...state,
                loading: false,
                travelPreferences: action.payload
            };

        case PROFILE_GET_VACATIONS:
            return {
                ...state,
                loading: false,
                vacations: action.payload
            };
        case PROFILE_GET_VACATIONS_BY_ID:
            return {
                ...state,
                loading: false,
                singleVacations: action.payload
            };
        case PROFILE_SET_VACATIONS:
            vacations = Object.assign([], state.vacations);
            if (typeof action.payload === "number") {
                index = vacations.findIndex(item => item.id === action.payload);
                if (index > -1) {
                    vacations.splice(index, 1);
                }
            } else {
                index = vacations.findIndex(item => item.id === action.payload.id);
                if (index > -1) {
                    vacations[index] = action.payload;
                } else {
                    vacations.push(action.payload);
                }
            }
            return {
                ...state,
                loading: false,
                vacations
            };
        case PROFILE_GET_SPECIAL:
            return {
                ...state,
                loading: false,
                specialAvailability: action.payload
            };
        case PROFILE_GET_SPECIAL_BY_ID:
            return {
                ...state,
                loading: false,
                singleSpecialAvailability: action.payload
            };
        case PROFILE_SET_SPECIAL:
            specialAvailability = Object.assign([], state.specialAvailability);
            if (typeof action.payload === "number") {
                index = specialAvailability.findIndex(item => item.id === action.payload);
                if (index > -1) {
                    specialAvailability.splice(index, 1);
                }
            } else {
                index = specialAvailability
                    .findIndex(item => item.id === action.payload.id);
                if (index > -1) {
                    specialAvailability[index] = action.payload;
                } else {
                    specialAvailability.push(action.payload);
                }
            }
            return {
                ...state,
                loading: false,
                specialAvailability
            };

        default:
            return state;
    }
}
